import type { FC } from 'react';

import { ApprovalStatusBar } from '@mint-lib/approval-flow-circuit';
import { useTranslation } from '@mint-lib/i18n';
import styled, { css } from '@mint-lib/styled';

import { Box, Typography } from '@myn/mui';

import { prepareApprovalStatusBarProps } from '../../../../utils/approvalFlow.js';

type Props = {
  innerObj?: ReturnType<typeof prepareApprovalStatusBarProps>;
  isPlanReadyForReview: boolean;
};

const Header: FC<Props> = ({ innerObj, isPlanReadyForReview }) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <TopHeaderContainer>
      <Typography variant="h2">{t('Buying Plan')}</Typography>
      {innerObj ? (
        <Box>
          <ApprovalStatusBar
            innerObj={innerObj}
            isDisabled={!isPlanReadyForReview}
          />
        </Box>
      ) : null}
    </TopHeaderContainer>
  );
};

export default Header;

const TopHeaderContainer = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
